module.exports = __webpack_public_path__ + "img/22_38.37243dfd.png";